import type { InnovatorCompaniesPortfolioSelectDto, InnovatorCompaniesProjectsSelectDto } from '@@types/api.types';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { queryKeys } from '@queries/keys';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type Nullable<T> = T | null | undefined;

export type ParentOrganizationPortfolioQueryParams = {
  limit?: Nullable<number>;
  page?: Nullable<number>;
  search?: Nullable<string>;
};

const buildQueryParams = (params: ParentOrganizationPortfolioQueryParams) => {
  const queryParams: Record<string, unknown> = {};

  if (params.limit) {
    queryParams.limit = params.limit;
  }

  if (params.page) {
    queryParams.page = params.page;
  }

  if (params.search) {
    queryParams.search = params.search;
  }

  return queryParams;
};

export const useParentOrganizationProjectsQuery = () => {
  const { apiGet } = useApi();

  return useQuery<InnovatorCompaniesProjectsSelectDto, ApiErrorWrapper>({
    queryFn: async () => {
      return await apiGet<InnovatorCompaniesProjectsSelectDto>({
        path: '/v1/innovator/companies/projects',
      });
    },
    queryKey: queryKeys.parentOrganizations.getProjects,
  });
};

export const useParentOrganizationPortfolioQuery = (params: ParentOrganizationPortfolioQueryParams) => {
  const { apiGet } = useApi();
  const queryParams = buildQueryParams(params);

  return useQuery<InnovatorCompaniesPortfolioSelectDto, ApiErrorWrapper>({
    placeholderData: keepPreviousData,
    queryFn: async () => {
      return await apiGet<InnovatorCompaniesPortfolioSelectDto>({
        path: '/v1/innovator/companies/portfolio',
        query: queryParams,
      });
    },
    queryKey: queryKeys.parentOrganizations.getPortfolio(queryParams),
    refetchOnWindowFocus: true,
  });
};
